module.exports = __webpack_public_path__ + "img/te_miniapp_code.cacf4789.png";